import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    FormControlLabel,
    Grid,
    Switch,
    TextField,
} from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

import DefaultApiService from "../../../../../infrastructure/api/default";
import { wrapFormikHandleChange } from "../../../../../infrastructure/utils/formatters";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import DropdownPicker from "../../../../components/shared/dropdown";

const validationSchema = Yup.object().shape({
  serial: Yup.string().required("لطفا این فیلد را پر کنید."),
  counterModel: Yup.string().required("لطفا این فیلد را پر کنید."),
  counterDataSource: Yup.string().required("لطفا این فیلد را پر کنید."),
  isActive: Yup.bool(),
});

const CounterInformationModifyPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);

  const onNavigateToListPage = () => {
    navigate("/BI/Grid/CounterInformation");
  };

  // Submit Action
  const onSubmit = async (formValue, { setSubmitting }) => {
    setLoading(true);
    const sendData = { ...data.substation, ...formValue };

    try {
      const res = await DefaultApiService.modifyApi(
        "BI/Grid/CounterInformation",
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");

      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={
              roleId !== "create" ? `ویرایش ${data?.counter?.serial}` : "ایجاد"
            }
          />

          <CardContent>
            <Formik
              initialValues={data.counter}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                const onMakeFormikVariable = (name) => ({
                  name: name,
                  fullWidth: true,
                  value: values[name],
                  error: errors[name] && touched[name],
                  helperText: errors[name] && touched[name] && errors[name],
                  variant: "outlined",
                });

                return (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6} lg={6}>
                        <TextField
                          label="شماره سریال"
                          type="string"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("serial")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <DropdownPicker
                          label="مدل"
                          onChange={(event) => {
                            setFieldValue("counterModel", event.target.value);
                          }}
                          list={data.counterModel}
                          {...onMakeFormikVariable("counterModel")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <DropdownPicker
                          label="منبع اطلاعات"
                          onChange={(event) => {
                            setFieldValue(
                              "counterDataSource",
                              event.target.value
                            );
                          }}
                          list={data.counterDataSource}
                          {...onMakeFormikVariable("counterDataSource")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <FormControlLabel
                          name="isActive"
                          value={values.isActive}
                          checked={values.isActive}
                          onChange={wrapFormikHandleChange(handleChange)}
                          control={<Switch />}
                          label="فعال"
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        container
                        justifyContent={"flex-end"}
                      >
                        <Button
                          disabled={isSubmitting}
                          variant="outlined"
                          size="large"
                          color="gray"
                          sx={{ mx: 1 }}
                          onClick={onNavigateToListPage}
                        >
                          انصراف
                        </Button>

                        <Button
                          disabled={isSubmitting}
                          variant="contained"
                          type="submit"
                          size="large"
                        >
                          {loading && (
                            <CircularProgress size={16} color="inherit" />
                          )}
                          {roleId !== "create" ? "ویرایش" : "ایجاد"}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                );
              }}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CounterInformationModifyPage;
